"use client";

/**
 * DiscoveryCollabsCard 컴포넌트
 * @description 콜랩 한 장. 상태 줄("Crew • 2d left" · "Submitted" · "Wrapping up")은 기존
 *   규칙(`toSuggestedCollabSubtitle`)을 그대로 쓴다. 시안의 `quick-card` 는 `ContentCard` 의
 *   정사각 형태 그대로다 — 여백 · 모서리 · 타이포가 한 값도 다르지 않아 따로 만들지 않는다.
 */
import { memo, useCallback } from "react";

import {
  DISCOVERY_COLLAB_IMAGE_SIZES,
  discoveryCollabsStyles,
} from "./DiscoveryCollabs.styles";
import type { DiscoveryCollabsCardProps } from "./DiscoveryCollabs.types";

import { trackDiscoveryCollabClicked } from "../../analytics";
import { toSuggestedCollabSubtitle } from "../../utils/suggestedCollabSubtitle";
import { routes } from "@/shared/config/routes";
import {
  AppImage,
  ContentCard,
  IMAGE_PLACEHOLDER,
  Reveal,
  REVEAL_STAGGER,
} from "@/shared/ui";

const DiscoveryCollabsCard = memo<DiscoveryCollabsCardProps>(
  ({ collab, index }) => {
    const track = useCallback(
      () => trackDiscoveryCollabClicked(collab, index),
      [collab, index],
    );
    return (
      <Reveal
        delay={index * REVEAL_STAGGER}
        className={discoveryCollabsStyles.card}
      >
        <ContentCard
          ratio="square"
          titleLines={1}
          media={
            <AppImage
              uri={collab.collabThumbnailUrl[0] ?? ""}
              fallback={IMAGE_PLACEHOLDER}
              sizes={DISCOVERY_COLLAB_IMAGE_SIZES}
            />
          }
          title={collab.collabTitle}
          metadata={toSuggestedCollabSubtitle(collab)}
          href={routes.collabs.detail(collab.collabId)}
          onClick={track}
        />
      </Reveal>
    );
  },
);

DiscoveryCollabsCard.displayName = "DiscoveryCollabsCard";

export default DiscoveryCollabsCard;
